// extracted by mini-css-extract-plugin
export default {"tech":"HW14_tech__jb8hI","loading":"HW14_loading__HVokR"};